import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Gallery.css';
import SEO from '../Components/SEO';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaTimes, FaSearchPlus, FaArrowLeft, FaArrowRight } from 'react-icons/fa';

// --- ORIGINAL IMAGES ---
import MODERNHOUSE from '../images/MODERNHOUSE.jpeg';
import APPARTMENTS from '../images/APPARTMENTS.jpeg';
import INTERIOR from '../images/INTERIOR.jpeg';
import MALLS from '../images/MALLS.png';
import HOMEATTACH from '../images/HOMEATTACH.jpeg';

// --- VARK SERIES 1-65 IMPORTS ---
import VARK1 from '../images/VARK1.jpeg';
import VARK2 from '../images/VARK2.jpeg';
import VARK3 from '../images/VARK3.jpeg';
import VARK4 from '../images/VARK4.jpeg';
import VARK5 from '../images/VARK5.jpeg';
import VARK6 from '../images/VARK6.jpeg';
import VARK7 from '../images/VARK7.jpeg';
import VARK8 from '../images/VARK8.jpeg';
import VARK9 from '../images/VARK9.jpeg';
import VARK10 from '../images/VARK10.jpeg';
import VARK11 from '../images/VARK11.jpeg';
import VARK12 from '../images/VARK12.jpeg';
import VARK13 from '../images/VARK13.jpeg';
import VARK14 from '../images/VARK14.jpeg';
import VARK15 from '../images/VARK15.jpeg';
import VARK16 from '../images/VARK16.jpeg';
import VARK17 from '../images/VARK17.jpeg';
import VARK18 from '../images/VARK18.jpeg';
import VARK19 from '../images/VARK19.jpeg';
import VARK20 from '../images/VARK20.jpeg';
import VARK21 from '../images/VARK21.jpeg';
import VARK22 from '../images/VARK22.jpeg';
import VARK23 from '../images/VARK23.jpeg';
import VARK24 from '../images/VARK24.jpeg';
import VARK25 from '../images/VARK25.jpeg';
import VARK26 from '../images/VARK26.jpeg';
import VARK27 from '../images/VARK27.jpeg';
import VARK28 from '../images/VARK28.jpeg';
import VARK30 from '../images/VARK30.jpeg';
import VARK31 from '../images/VARK31.jpeg';
import VARK32 from '../images/VARK32.jpeg';
import VARK33 from '../images/VARK33.jpeg';
import VARK34 from '../images/VARK34.jpeg';
import VARK35 from '../images/VARK35.jpeg';
import VARK36 from '../images/VARK36.jpeg';
import VARK37 from '../images/VARK37.jpeg';
import VARK38 from '../images/VARK38.jpeg';
import VARK39 from '../images/VARK39.jpeg';
import VARK40 from '../images/VARK40.jpeg';
import VARK41 from '../images/VARK41.jpeg';
import VARK42 from '../images/VARK42.jpeg';
import VARK43 from '../images/VARK43.jpeg';
import VARK44 from '../images/VARK44.jpeg';
import VARK45 from '../images/VARK45.jpeg';
import VARK46 from '../images/VARK46.jpeg';
import VARK47 from '../images/VARK47.jpeg';
import VARK48 from '../images/VARK48.jpeg';
import VARK49 from '../images/VARK49.jpeg';
import VARK50 from '../images/VARK50.jpeg';
import VARK51 from '../images/VARK51.jpeg';
import VARK52 from '../images/VARK52.jpeg';
import VARK53 from '../images/VARK53.jpeg';
import VARK54 from '../images/VARK54.jpeg';
import VARK55 from '../images/VARK55.jpeg';
import VARK56 from '../images/VARK56.jpeg';
import VARK57 from '../images/VARK57.jpeg';
import VARK58 from '../images/VARK58.jpeg';
import VARK59 from '../images/VARK59.jpeg';
import VARK60 from '../images/VARK60.jpeg';
import VARK61 from '../images/VARK61.jpeg';
import VARK62 from '../images/VARK62.jpeg';
import VARK63 from '../images/VARK63.jpeg';
import VARK64 from '../images/VARK64.jpeg';
import VARK65 from '../images/VARK65.jpeg';

const varkImages = [
  VARK1,
  VARK2,
  VARK3,
  VARK4,
  VARK5,
  VARK6,
  VARK7,
  VARK8,
  VARK9,
  VARK10,
  VARK11,
  VARK12,
  VARK13,
  VARK14,
  VARK15,
  VARK16,
  VARK17,
  VARK18,
  VARK19,
  VARK20,
  VARK21,
  VARK22,
  VARK23,
  VARK24,
  VARK25,
  VARK26,
  VARK27,
  VARK28,
  VARK30,
  VARK31,
  VARK32,
  VARK33,
  VARK34,
  VARK35,
  VARK36,
  VARK37,
  VARK38,
  VARK39,
  VARK40,
  VARK41,
  VARK42,
  VARK43,
  VARK44,
  VARK45,
  VARK46,
  VARK47,
  VARK48,
  VARK49,
  VARK50,
  VARK51,
  VARK52,
  VARK53,
  VARK54,
  VARK55,
  VARK56,
  VARK57,
  VARK58,
  VARK59,
  VARK60,
  VARK61,
  VARK62,
  VARK63,
  VARK64,
  VARK65
];

const galleryImages = [
  ...varkImages.map((img, index) => {
    let category = 'Completed Projects';
    const mod = index % 4;
    if (mod === 1) category = 'Ongoing Projects';
    else if (mod === 2) category = 'Construction Process';
    else if (mod === 3) category = 'Finished Interiors';
    return {
      src: img,
      title: `VARK Project ${index + 1}`,
      category: category
    };
  }),
  { src: MODERNHOUSE, title: 'Modern Villa Design', category: 'Completed Projects' },
  { src: APPARTMENTS, title: 'Luxury Apartments', category: 'Ongoing Projects' },
  { src: INTERIOR, title: 'Premium Interior', category: 'Finished Interiors' },
  { src: MALLS, title: 'Commercial Complex', category: 'Completed Projects' },
  { src: HOMEATTACH, title: 'Structural Planning', category: 'Construction Process' }
];

const Gallery = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [lightboxIndex, setLightboxIndex] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 1000, once: true });
  }, []);

  const categories = ['All', 'Completed Projects', 'Ongoing Projects', 'Construction Process', 'Finished Interiors'];

  const filteredImages = galleryImages.filter(img => {
    if (activeCategory === 'All') return true;
    return img.category === activeCategory;
  });

  const openLightbox = (index) => {
    setLightboxIndex(index);
  };

  const closeLightbox = () => {
    setLightboxIndex(null);
  };

  const prevImage = (e) => {
    e.stopPropagation();
    setLightboxIndex(prev => (prev === 0 ? filteredImages.length - 1 : prev - 1));
  };

  const nextImage = (e) => {
    e.stopPropagation();
    setLightboxIndex(prev => (prev === filteredImages.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className='gallery-page'>
      <SEO
        title='Project Gallery'
        description='Explore our construction portfolio of luxury villas, office buildings, modular interiors, and structural planning built by VARK Builders Private Limited.'
      />

      <div className='gallery-banner'>
        <div className='container' data-aos='fade-up'>
          <h1>Our Project <span>Gallery</span></h1>
          <p>Visualizing your dreams through our engineering excellence.</p>
        </div>
      </div>

      <section className='gallery-grid-section'>
        <div className='container'>
          {/* Category Tabs */}
          <div className='gallery-tabs' data-aos='fade-up'>
            {categories.map((cat) => (
              <button
                key={cat}
                className={`gallery-tab-btn ${activeCategory === cat ? 'active' : ''}`}
                onClick={() => {
                  setActiveCategory(cat);
                  closeLightbox();
                }}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Masonry Grid */}
          <div className='masonry-grid' data-aos='fade-up'>
            {filteredImages.map((image, index) => (
              <div
                className='masonry-item'
                key={index}
                onClick={() => openLightbox(index)}
              >
                <div className='image-wrapper'>
                  <img src={image.src} alt={image.title} loading='lazy' />
                  <div className='image-overlay'>
                    <span className='category-label'>{image.category}</span>
                    <h3>{image.title}</h3>
                    <div className='search-icon-badge'><FaSearchPlus /></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Popup Modal */}
      {lightboxIndex !== null && (
        <div className='lightbox-modal' onClick={closeLightbox}>
          <button className='lightbox-close-btn' onClick={closeLightbox} aria-label='Close Lightbox'>
            <FaTimes />
          </button>
          
          <button className='lightbox-nav-btn prev' onClick={prevImage} aria-label='Previous Image'>
            <FaArrowLeft />
          </button>
          
          <div className='lightbox-content-box' onClick={(e) => e.stopPropagation()}>
            <img 
              src={filteredImages[lightboxIndex].src} 
              alt={filteredImages[lightboxIndex].title} 
              className='lightbox-image' 
            />
            <div className='lightbox-caption'>
              <span className='caption-category'>{filteredImages[lightboxIndex].category}</span>
              <h3>{filteredImages[lightboxIndex].title}</h3>
            </div>
          </div>
          
          <button className='lightbox-nav-btn next' onClick={nextImage} aria-label='Next Image'>
            <FaArrowRight />
          </button>
        </div>
      )}

      <section className='gallery-cta'>
        <div className='container' data-aos='fade-up'>
          <h2>Ready to Build Your <span>Dream Project?</span></h2>
          <p>Partner with the best builders in Madurai for your next construction venture.</p>
          <Link to='/contact' className='cta-btn'>Start Your Journey</Link>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
